module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ideas":"Ideas and development proposals"},"fi":{"ideas":"Ideat ja kehitysehdotukset"},"sv":{"ideas":"Idés och utvecklingsförslags"},"de":{"ideas":"Idees und Vorschlags"},"ko":{"ideas":"아이디어 및 개발 제안"}}')
  delete Component.options._Ctor
}
